import { useCallback, useMemo, useState } from "react";
import { Dropdown, Menu } from "antd";
import { getSchoolLink } from "../service/api";
import { useQuery } from "react-query";
import TableContainer from "../../../common/table/TableContainer";
import {
  CheckOutlined,
  CloseOutlined,
  CopyOutlined,
  DeleteOutlined,
  EllipsisOutlined,
  EyeOutlined,
} from "@ant-design/icons";

const CampaignLinkTable = ({ business, token, merchantId }) => {
  const [justCopied, setJustCopied] = useState(false);
  const { apiKey, apiToken } = business || {};
  const { data, isLoading, error } = useQuery({
    queryKey: ["school-payment-links", apiKey, apiToken, token],
    queryFn: getSchoolLink,
    enabled: !!apiKey && !!token && !!apiToken,
  });

  const paymentLinks = useMemo(() => {
    if (!data || !data.data) return [];

    return [
      {
        id: data.data.id,
        businessName: data.data.schoolName,
        publicToken: data.data.publicToken,
        status: data.data.status,
        closedMonths: data.data.closedMonths?.split(",") ?? [],
        createdDate: data.data.createdAt,
      },
    ];
  }, [data]);

  const copyToClipboard = useCallback(async (textToCopy) => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setJustCopied(true);
      setTimeout(() => setJustCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
      // You could add toast notification here
    }
  }, []);

  const columns = [
    {
      Header: "Lien de campagne",
      accessor: "publicToken",
      filterable: false,
      Cell: ({ value, row }) => {
        const record = row.original;

        return (
          <>
            <span
              className="inline-flex items-center gap-2"
              onClick={() =>
                window.open(
                  `${process.env.REACT_APP_PAXITY_FEES}?rt=${encodeURIComponent(`${record.businessName}+${merchantId}+${token}`)}`,
                  "_blank",
                )
              }
              style={{ cursor: "pointer", color: "#1890ff" }}
            >
              {`${process.env.REACT_APP_PAXITY_FEES}/${value}`}
            </span>{" "}
            {justCopied && (
              <CopyOutlined className="h-4 w-4 text-green-600 animate-pulse" />
            )}
          </>
        );
      },
    },
    {
      Header: "Bussiness",
      accessor: "businessName",
      filterable: false,
      Cell: ({ value }) => <span>{value || "Non défini"}</span>,
    },
    {
      Header: "Date de création",
      accessor: "createdDate",
      filterable: false,
      Cell: ({ value }) => {
        return value ? (
          <span className="namesTrans">
            {new Date(value).toLocaleString("fr-FR", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })}
          </span>
        ) : (
          <span> Non défini </span>
        );
      },
    },
    {
      Header: "Campagnes",
      accessor: "closedMonths",
      filterable: false,
      Cell: ({ value }) => <span>{value.length}</span>,
    },
    {
      Header: "Statut",
      accessor: "status",
      filterable: false,
      Cell: ({ value }) => {
        if (value == "ACTIVE") {
          return (
            <div className="status-active">
              <CheckOutlined className="status-icon" />
              <span> ACTIF </span>
            </div>
          );
        } else {
          return (
            <div className="status-blocked">
              <CloseOutlined className="status-icon" />
              <span>INACTIF</span>
            </div>
          );
        }
      },
    },
    {
      Header: "Action",
      accessor: "action",
      Cell: ({ row }) => {
        const record = row.original;
        return (
          <Dropdown
            overlay={
              <Menu>
                <Menu.Item
                  key="1"
                  icon={<EyeOutlined />}
                  onClick={() =>
                    copyToClipboard(
                      `${process.env.REACT_APP_PAXITY_FEES}?rt=${encodeURIComponent(`${record.businessName}+${merchantId}+${token}`)}`,
                    )
                  }
                >
                  Copier le lien
                </Menu.Item>
                {/* <Menu.Item
                  key="4"
                  icon={<DeleteOutlined />}
                  // onClick={() => confirmDeleteModal(record)}
                  danger
                  // disabled={record.paymentStatus == "SUCCESS" ? true : false}
                >
                  Supprimer
                </Menu.Item> */}
              </Menu>
            }
            trigger={["click"]}
          >
            <div className="action-menu-trigger">
              <EllipsisOutlined />
            </div>
          </Dropdown>
        );
      },
    },
  ];

  return (
    <>
      <TableContainer
        columns={columns}
        data={paymentLinks ?? []}
        isGlobalSearch={false}
        isPaginationButton={false}
        isGlobalFilter={false}
        customPageSize={10}
        className="custom-header-css"
        divClass="table-responsive table-card mb-3"
        tableClass="align-middle table-nowrap"
        theadClass="table-light"
        isLoading={false}
        isError={false}
        isLoadingSkeleton={isLoading}
        error={error}
      ></TableContainer>
    </>
  );
};
export default CampaignLinkTable;
